// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2eKNP","errors":"Errors_errors__aUzw3"};